import React, {useEffect, useRef, useState} from "react";
import {toJS} from "mobx";
import {inject, observer} from "mobx-react";
import {Link} from "gatsby";
import {
  BRANDS,
  defineCountryTextCode,
  defineIsDirRTL,
  IS_SERVER
} from "../../../common";
import {throwParamsToLink} from "../../../helpers";
import {useOutsideClickAlerter} from "../../../helpers/customHooks";
import '../../../assets/fonts/Roboto/stylesheet.css';
import './style.scss';

const DropDownLangList = inject('appStore', 'kafkaStore')(observer((props) => {
  const [isDirRTL, setIsDirRTL] = useState(false);
  const [countryData, setCountryData] = useState({});
  const [landingLangsData, setLandingLangsData] = useState([]); // массив объектов с данными по языкам для лендинга по названию и бренду
  const [landingLangs, setLandingLangs] = useState([]); // массив языков для текущего лендинга по названию и бренду
  const [sortedLangsList, setSortedLangsList] = useState([]);
  const [dropDownList, setDropDownList] = useState([]);
  const [isDropDownListVisible, setIsDropDownListVisible] = useState(false);
  const [isActive, setActive] = useState("false");
  const listRef = useRef();

  const pathArr = !IS_SERVER && window.location.pathname.split('/').filter(Boolean);
  const brandName = props.appStore.brandName;
  const currentLang = !IS_SERVER && pathArr.find(item => item.length === 2);
  const landingName = !IS_SERVER && pathArr[pathArr.length - 1];

  const handleShowList = () => {
    setIsDropDownListVisible(!isDropDownListVisible);
    setActive(!isActive);
  }

  useEffect(() => {
    setIsDirRTL(defineIsDirRTL(currentLang));
  }, []);

  useEffect(() => {
    if (brandName === BRANDS.cupis) {
      const countries = require("../../../../static/data/country_data_dev.json")
      const country = Array.from(countries).find(item => item.country_id = 643);
      country.lang_id = 1;
      setCountryData(country)
    } else if (brandName !== BRANDS.cupis && props.appStore.CountryDataList && currentLang) {
      setCountryData(props.appStore.getCountryDataByName(defineCountryTextCode(currentLang)));
    }
  }, [props.appStore.CountryDataList, currentLang, brandName]);

  useEffect(() => {
    if (props.appStore.landingsLangList) {
      const langsListByLanding = toJS(props.appStore.landingsLangList);
      // объект с массивами языков по брендам для текущего лендинга по названию
      const obj = langsListByLanding.find(item => item[landingName]);
      // массив языков для текущего лендинга по названию и бренду
      const langs = obj[landingName][brandName]?.langs;

      setLandingLangs(langs);
    }
  }, [props.appStore.landingsLangList]);

  useEffect(() => {
    if (countryData && landingLangs && landingLangs.length > 0) {
      const tempArr = [];
      landingLangs.forEach(lang => {
        const country = props.appStore.getCountryDataByName(defineCountryTextCode(lang));
        const result = {
          lang,
          country_code: defineCountryTextCode(lang).toUpperCase(),
          lang_id: lang === 'ru' ? 1 : (lang === 'en' ? 2 : country.lang_id) // ru на случай cupis
        };
        tempArr.push(result);
        return result
      })
      setLandingLangsData(tempArr);
    }
  }, [countryData && landingLangs]);

  // Сортировка списка языков по lang_id - по аналогии со списком на основном сайте
  // В конец списка выносятся туркменский и украинский (есть на некоторых лендах)
  useEffect(() => {
    if (landingLangsData && landingLangsData.length > 0) {
      const sortedData = landingLangsData.sort((a, b) => {
        if (a.country_code === 'TM' || a.country_code === 'UA') {
          return b.lang_id - a.lang_id
        }
        return a.lang_id - b.lang_id
      });
      setSortedLangsList(sortedData);
    }
  }, [landingLangsData]);

  useEffect(() => {
    if (sortedLangsList) {
      const list = sortedLangsList.map(item => {
        const { lang, country_code } = item;
        const tempArr = Array.from(pathArr.filter(item => item !== 'promo'));
        tempArr.splice(1, 1, `${lang}`);
        const newPath = tempArr.join('/');
        const params = throwParamsToLink();
        const newLangPageLink = `/${newPath}/` + params;
        return (
          <li key={country_code} className="dropdown__list-item">
            <Link className="dropdown__link" to={`${newLangPageLink}`}>
              <span className={`dropdown__img with-flag with-flag_${lang}`} />
              <span className="dropdown__text">{lang.toUpperCase()}</span>
            </Link>
          </li>
        )
      })
      setDropDownList(list)
    }
  }, [sortedLangsList]);

  useOutsideClickAlerter(isDropDownListVisible, listRef, setIsDropDownListVisible);

  return (
    <>
      {dropDownList && dropDownList.length > 1
        ? <div className={`dropdown dropdown_${currentLang} dropdown_${brandName} ${isDirRTL ? 'dropdown_left-side' : ''}`}>
          <div className={`dropdown__btn dropdown__btn_${brandName} ${isActive ? "inactive" : 'active'}`} onClick={handleShowList}>
            <span className={`dropdown__img with-flag with-flag_${currentLang}`}/>
            <span className="dropdown__text">{currentLang.toUpperCase()}</span>
          </div>
          {isDropDownListVisible
            ? <ul ref={listRef} className={`dropdown__list dropdown__list_${brandName}`} dir="ltr">
              {dropDownList}
            </ul>
            : ''
          }
        </div>
        : ''
      }
    </>
  )
}));

export default DropDownLangList;